/**
 * Utility functions for managing styles of different themes
 */

export const CURRENT_APP_THEME = process.env.REACT_APP_THEME_ENV;

/**
 *  Retrieve style associated with the current theme
 *  @param stylesMap A mapping of styles for each theme
 *  @returns the selected style
 */
export function getStyle(stylesMap) {
    return stylesMap[CURRENT_APP_THEME];
}

export function getValue(values) {
    return values[CURRENT_APP_THEME];
}

/**
 *  Retrieve JSX layout using the current theme
 *  @param layouts A map of components
 *  @returns a component
 */ 
export const getLayout = (layouts) => {
    return getValue(layouts);
}

/**
 *   Merge source styles into destination styles
 *   @param destinationStyles the destination object
 *   @param sourceStyles the source object
 *   @returns merged object
 */
export function mergeStyles(destinationStyles, sourceStyles) {
    // get source style names
    const sourceStyleNames = Object.keys(sourceStyles);

    /*  Add object corresponding to sourceStyleName into destinationStyles
        If sourceStyleName is a key in both sourceStyles and destinationStyles,
        merge the 2 sourceStyleName objects into one with sourceStyles
        overriding any similar properties in destinationStyles.
        e.g const sourceStyles = {
                                    list: {
                                        fontSize: theme.spacing(2),   
                                    }
                                 }

        const destinationStyles =  { 
                                        menuCard: {
                                           marginLeft: ThemeConsumer.spacing(1),
                                        },
                                        list: {
                                           fontSize: theme.spacing(6)
                                           color:'white'
                                        }
                                    }
    
        After merging, destinationStyles = {
                                                menuCard: {
                                                    marginLeft: ThemeConsumer.spacing(1),
                                                },
                                                list: {
                                                    fontSize: theme.spacing(2),
                                                    color:'white'
                                                }
                                            }
    */
    for (const sourceStyleName of sourceStyleNames) {
        destinationStyles[sourceStyleName] =
            sourceStyleName in destinationStyles ? { ...destinationStyles[sourceStyleName], ...sourceStyles[sourceStyleName] } : sourceStyles[sourceStyleName];
    }

    return destinationStyles;
}
